import { render, staticRenderFns } from "./SpecimensPerTournamentModal.vue?vue&type=template&id=62231770"
import script from "./SpecimensPerTournamentModal.vue?vue&type=script&lang=js"
export * from "./SpecimensPerTournamentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports